import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ClusterHealth } from "@graylog/enterprise-api";
import useHealthModuleVisible from "./useHealthModuleVisible";
const POLL_INTERVAL_MS = 5e3;
const HEALTH_REPORT_QUERY_KEY = ["health", "cluster-report"];
const fetchHealthReport = () => ClusterHealth.getClusterHealth(false, { requestShouldExtendSession: false });
const useHealthReport = () => {
  const enabled = useHealthModuleVisible();
  return useQuery({
    queryKey: HEALTH_REPORT_QUERY_KEY,
    queryFn: fetchHealthReport,
    refetchInterval: POLL_INTERVAL_MS,
    enabled,
    placeholderData: keepPreviousData
  });
};
export default useHealthReport;
